import { Container } from '@mui/material';
import BasePage from '../BasePage';
import AdminLayout from '../../components/AdminLayout';
import AdminPageHeader from '../../components/admin/shared/AdminPageHeader';
import AdminLoadingState from '../../components/admin/shared/AdminLoadingState';
import BillingTabs from '../../components/admin/billing/BillingTabs';
import { useAdminBilling } from '../../hooks/admin/useAdminBilling';

/**
 * AdminBilling - Subscriptions and billing management page
 *
 * Section 7: Subscriptions & Billing
 * - Subscription overview with metrics and table
 * - Payment issues tracking and retry management
 * - Revenue analytics with MRR, ARR, churn analysis
 * - Paddle integration status and webhook monitoring
 */
export default function AdminBilling() {
  const { billingData, isLoading, refresh, cancelSubscription, retryPayment } = useAdminBilling();

  if (isLoading && !billingData) {
    return <AdminLoadingState message="Loading billing data..." />;
  }

  return (
    <BasePage title="Billing & Subscriptions | CribCritic Admin" description="Manage billing">
      <AdminLayout>
        <Container maxWidth="xl">
          <AdminPageHeader
            title="Subscriptions & Billing"
            subtitle="Manage subscriptions, payment issues, revenue analytics, and Paddle integration"
          />

          <BillingTabs
            data={billingData}
            loading={isLoading}
            onRefresh={refresh}
            onCancelSubscription={cancelSubscription}
            onRetryPayment={retryPayment}
          />
        </Container>
      </AdminLayout>
    </BasePage>
  );
}
